module.exports = __webpack_public_path__ + "static/img/RussellTaylors_logo.0e73759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/RussellTaylors_logo.png
// module id = x1Xc
// module chunks = 0